<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    @if (isPageLoading) {
      <div class="view-role-training__loading" role="status" aria-live="polite" aria-label="Loading">
        <img src="/assets/spinner.gif" class="view-role-training__spinner" alt="" />
      </div>
    } @else {
      <div class="facility-heading">View Role Training</div>
      @if (course) {
        <div class="role-cards">
          <div class="role-cards__header">
            <h2 class="role-cards__title">{{ course.roleName }} courses</h2>
            @if (showEditButton) {
              <button type="button" class="role-cards__add" (click)="openAdd()" title="Add another course to {{ course.roleName }}">
                <mat-icon>add</mat-icon> Add Course
              </button>
            }
          </div>
          <div class="role-cards__grid">
            @for (c of roleCourses; track c.id; let i = $index) {
              <a class="role-card" [class.role-card--current]="c.id === courseId" [routerLink]="['/view-role-training', c.id]">
                <span class="role-card__title"><span class="role-card__order">{{ i + 1 }}</span>{{ c.title }}</span>
                <span class="role-card__desc">{{ c.description || 'No description' }}</span>
                <span class="role-card__meta">
                  <span class="role-card__tag" [class.role-card__tag--optional]="!c.isMandatory">{{ c.isMandatory ? 'Mandatory' : 'Optional' }}</span>
                  <span class="role-card__tag" [class.role-card__tag--inactive]="!c.isActive">{{ c.status }}</span>
                </span>
              </a>
            }
          </div>
        </div>
      }
      @if (course) {
        <form>
          <div class="designatedFacilityForm">
            <div class="review-form-fileds-status">
              <span class="heading">{{ course.title }}</span>
              <span class="reviewstatus-{{ course.isActive ? 'active' : 'inactive' }}">{{ course.status.toUpperCase() }}</span>
            </div>
            <div class="review-form-fileds">
              <span class="label">Role</span>
              <span class="answers">{{ course.roleName }}</span>
            </div>
            <div class="review-form-fileds">
              <span class="label">Requirement</span>
              <span class="answers">{{ course.isMandatory ? 'Mandatory' : 'Optional' }}</span>
            </div>
            <div class="review-form-fileds">
              <span class="label">Video</span>
              <span class="answers">
                @if (hasCourseVideo(course)) {
                  <span class="video-link-row">
                    <span class="video-link-row__name">{{ getVideoDisplayName(course) }}</span>
                    <button
                      type="button"
                      class="video-link-row__open"
                      [class.video-link-row__open--disabled]="!coursePlayableUrl"
                      [disabled]="!coursePlayableUrl"
                      (click)="openVideo(coursePlayableUrl)"
                      [attr.aria-label]="'Open ' + getVideoDisplayName(course) + ' in new tab'">
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                  </span>
                } @else {
                  —
                }
              </span>
            </div>
            <div class="review-form-fileds">
              <span class="label">Description</span>
              <span class="answers">{{ course.description || '—' }}</span>
            </div>
            <div class="review-form-fileds">
              <span class="label">Version</span>
              <span class="answers">{{ course.version }}</span>
            </div>
            <div class="h-30"></div>
            <div class="form-buttons" [hidden]="!showEditButton">
              <button class="submit-form-button" type="button" (click)="navigate()">Edit</button>
              <a class="submit-form-button cancel-button" routerLink="/role-training-list">Cancel</a>
            </div>
          </div>
        </form>
      }

      <div class="user-mgmt-page">
        <h2 class="user-mgmt-page__title">Acknowledgements</h2>
        <p class="user-mgmt-page__subtitle">Completion records for audit and compliance.</p>
        <section class="user-mgmt-page__table-card">
          @if (acknowledgements.length === 0) {
            <p>No acknowledgements recorded yet.</p>
          }
          <table mat-table class="fileList primary" [dataSource]="acknowledgements" [hidden]="acknowledgements.length === 0">
            <ng-container matColumnDef="User">
              <th mat-header-cell *matHeaderCellDef>User</th>
              <td mat-cell *matCellDef="let row">
                {{ row.userName }}<br />
                <small>{{ row.email }}</small>
              </td>
            </ng-container>
            <ng-container matColumnDef="Completed">
              <th mat-header-cell *matHeaderCellDef>Completed (UTC)</th>
              <td mat-cell *matCellDef="let row">{{ row.acknowledgedOnUtc | date:'yyyy-MM-dd HH:mm' }}</td>
            </ng-container>
            <ng-container matColumnDef="VideoUrl">
              <th mat-header-cell *matHeaderCellDef>Video recorded</th>
              <td mat-cell *matCellDef="let row">
                @if (hasAckVideo(row)) {
                  <span class="video-link-row">
                    <span class="video-link-row__name">{{ getAckVideoDisplayName(row) }}</span>
                    <button
                      type="button"
                      class="video-link-row__open"
                      [class.video-link-row__open--disabled]="!row.playableVideoUrl"
                      [disabled]="!row.playableVideoUrl"
                      (click)="openVideo(row.playableVideoUrl)"
                      [attr.aria-label]="'Open ' + getAckVideoDisplayName(row) + ' in new tab'">
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                  </span>
                } @else {
                  —
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
          </table>
        </section>
      </div>
    }
  </div>
</div>
@if (showAddForm) {
  <div class="add-backdrop" (click)="closeAdd()">
    <div class="add-modal" role="dialog" aria-modal="true" aria-labelledby="addTitle" (click)="$event.stopPropagation()">
      <h2 id="addTitle">Add course to {{ course?.roleName }}</h2>

      <label for="newTitle">Name</label>
      <input id="newTitle" type="text" name="newTitle" [(ngModel)]="newTitle" maxlength="200" autofocus />
      @if (addSubmitted && !newTitle.trim()) {
        <p class="add-modal__error">Name is required.</p>
      }

      <label for="newDescription">Description</label>
      <textarea id="newDescription" name="newDescription" rows="3" [(ngModel)]="newDescription"></textarea>

      <label>Video source</label>
      <div class="add-modal__source">
        <label class="add-modal__check">
          <input type="radio" name="newVideoSource" value="link" [checked]="newVideoSource === 'link'" (change)="onVideoSourceChange('link')" />
          Video link
        </label>
        <label class="add-modal__check">
          <input type="radio" name="newVideoSource" value="upload" [checked]="newVideoSource === 'upload'" (change)="onVideoSourceChange('upload')" />
          Upload video
        </label>
      </div>

      @if (newVideoSource === 'link') {
        <input id="newVideoUrl" type="url" name="newVideoUrl" [(ngModel)]="newVideoUrl" placeholder="https://" />
        @if (addSubmitted && videoInvalid) {
          <p class="add-modal__error">Enter a valid https video link.</p>
        }
      } @else {
        <input id="newVideoFile" type="file"
               accept="video/mp4,video/webm,video/ogg,video/quicktime,.mp4,.webm,.ogg,.mov"
               (change)="onVideoSelected($event)" />
        @if (uploadedFileName) {
          <p class="add-modal__meta">{{ uploadedFileName }}</p>
        }
        @if (isUploading) {
          <p class="add-modal__meta">Uploading… {{ uploadProgress }}%</p>
        }
        @if (addSubmitted && videoInvalid && !isUploading) {
          <p class="add-modal__error">Please upload a video file.</p>
        }
      }

      <label class="add-modal__check">
        <input type="checkbox" name="newIsMandatory" [(ngModel)]="newIsMandatory" />
        Mandatory (must be completed before using the portal)
      </label>

      <div class="add-modal__actions">
        <button type="button" class="add-btn add-btn--secondary" (click)="closeAdd()">Cancel</button>
        <button type="button" class="add-btn add-btn--primary" (click)="saveAdd()" [disabled]="isSaving || isUploading">
          {{ isSaving ? 'Saving...' : 'Add course' }}
        </button>
      </div>
    </div>
  </div>
}
<app-footer></app-footer>
